import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../App';
import { PlusIcon, MinusIcon, TrashIcon, ShoppingBagIcon, ArrowRightIcon } from 'lucide-react';
export function Cart() {
  const {
    cart,
    updateQuantity,
    removeFromCart
  } = useContext(CartContext);
  const navigate = useNavigate();
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  // Calculate subtotal
  const subtotal = cart.reduce((total, item) => total + item.product.price * item.quantity, 0);
  // Shipping cost (free over $100)
  const shippingCost = subtotal > 100 ? 0 : 10;
  // Total cost
  const total = subtotal + shippingCost;
  const handleCheckout = () => {
    setIsCheckingOut(true);
    // In a real app, this would navigate to checkout page or process
    setTimeout(() => {
      alert('This is a demo. In a real app, you would proceed to payment.');
      setIsCheckingOut(false);
    }, 1500);
  };
  // If cart is empty
  if (cart.length === 0) {
    return <div className="container mx-auto px-4 py-16 text-center" data-id="element-105">
        <div className="max-w-md mx-auto" data-id="element-106">
          <div className="bg-gray-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6" data-id="element-107">
            <ShoppingBagIcon size={32} className="text-gray-400" data-id="element-108" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-109">
            Your Cart is Empty
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-110">
            Looks like you haven't added any products to your cart yet.
          </p>
          <Link to="/" className="px-6 py-3 bg-green-600 text-white font-medium rounded-full hover:bg-green-700 transition" data-id="element-111">
            Start Shopping
          </Link>
        </div>
      </div>;
  }
  return <div className="bg-gray-50 min-h-screen" data-id="element-112">
      <div className="container mx-auto px-4 py-8" data-id="element-113">
        <h1 className="text-3xl font-bold text-gray-800 mb-8" data-id="element-114">Your Cart</h1>
        <div className="flex flex-col lg:flex-row gap-8" data-id="element-115">
          {/* Cart Items */}
          <div className="lg:w-2/3" data-id="element-116">
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6" data-id="element-117">
              <div className="p-6" data-id="element-118">
                <table className="w-full" data-id="element-119">
                  <thead data-id="element-120">
                    <tr className="border-b border-gray-200" data-id="element-121">
                      <th className="text-left pb-4" data-id="element-122">Product</th>
                      <th className="text-center pb-4 hidden sm:table-cell" data-id="element-123">
                        Price
                      </th>
                      <th className="text-center pb-4" data-id="element-124">Quantity</th>
                      <th className="text-right pb-4" data-id="element-125">Total</th>
                    </tr>
                  </thead>
                  <tbody data-id="element-126">
                    {cart.map(item => <tr key={item.product.id} className="border-b border-gray-200 last:border-0" data-id="element-127">
                        <td className="py-4" data-id="element-128">
                          <div className="flex items-center" data-id="element-129">
                            <div className="w-16 h-16 rounded overflow-hidden flex-shrink-0 cursor-pointer" onClick={() => navigate(`/product/${item.product.id}`)} data-id="element-130">
                              <img src={item.product.image} alt={item.product.name} className="w-full h-full object-cover" data-id="element-131" />
                            </div>
                            <div className="ml-4" data-id="element-132">
                              <h3 className="font-medium text-gray-800 hover:text-green-600 transition cursor-pointer" onClick={() => navigate(`/product/${item.product.id}`)} data-id="element-133">
                                {item.product.name}
                              </h3>
                              <p className="text-sm text-gray-500 capitalize" data-id="element-134">
                                {item.product.subcategory}
                              </p>
                              <button onClick={() => removeFromCart(item.product.id)} className="text-red-500 hover:text-red-700 text-sm flex items-center mt-2" data-id="element-135">
                                <TrashIcon size={14} className="mr-1" data-id="element-136" /> Remove
                              </button>
                            </div>
                          </div>
                        </td>
                        <td className="py-4 text-center hidden sm:table-cell" data-id="element-137">
                          <span className="text-gray-800" data-id="element-138">
                            ${item.product.price.toLocaleString()}
                          </span>
                        </td>
                        <td className="py-4" data-id="element-139">
                          <div className="flex items-center justify-center" data-id="element-140">
                            <button onClick={() => updateQuantity(item.product.id, item.quantity - 1)} className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200" data-id="element-141">
                              <MinusIcon size={16} data-id="element-142" />
                            </button>
                            <span className="mx-3 w-8 text-center" data-id="element-143">
                              {item.quantity}
                            </span>
                            <button onClick={() => updateQuantity(item.product.id, item.quantity + 1)} className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200" data-id="element-144">
                              <PlusIcon size={16} data-id="element-145" />
                            </button>
                          </div>
                        </td>
                        <td className="py-4 text-right" data-id="element-146">
                          <span className="font-medium text-gray-800" data-id="element-147">
                            $
                            {(item.product.price * item.quantity).toLocaleString()}
                          </span>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="flex justify-between items-center" data-id="element-148">
              <button onClick={() => navigate('/')} className="text-green-600 hover:text-green-800 flex items-center" data-id="element-149">
                <ArrowRightIcon size={18} className="mr-1 transform rotate-180" data-id="element-150" />
                Continue Shopping
              </button>
            </div>
          </div>
          {/* Order Summary */}
          <div className="lg:w-1/3" data-id="element-151">
            <div className="bg-white rounded-lg shadow-sm overflow-hidden sticky top-8" data-id="element-152">
              <div className="p-6" data-id="element-153">
                <h2 className="text-xl font-bold text-gray-800 mb-6" data-id="element-154">
                  Order Summary
                </h2>
                <div className="space-y-4 mb-6" data-id="element-155">
                  <div className="flex justify-between" data-id="element-156">
                    <span className="text-gray-600" data-id="element-157">Subtotal</span>
                    <span className="text-gray-800 font-medium" data-id="element-158">
                      ${subtotal.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-159">
                    <span className="text-gray-600" data-id="element-160">Shipping</span>
                    <span className="text-gray-800 font-medium" data-id="element-161">
                      {shippingCost === 0 ? 'Free' : `$${shippingCost.toLocaleString()}`}
                    </span>
                  </div>
                  <div className="border-t border-gray-200 pt-4" data-id="element-162">
                    <div className="flex justify-between" data-id="element-163">
                      <span className="text-lg font-bold text-gray-800" data-id="element-164">
                        Total
                      </span>
                      <span className="text-lg font-bold text-green-600" data-id="element-165">
                        ${total.toLocaleString()}
                      </span>
                    </div>
                    <p className="text-gray-500 text-sm mt-1" data-id="element-166">
                      {subtotal < 100 && 'Add $' + (100 - subtotal).toLocaleString() + ' more for free shipping'}
                    </p>
                  </div>
                </div>
                <button onClick={handleCheckout} disabled={isCheckingOut} className={`w-full py-3 px-6 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition flex items-center justify-center ${isCheckingOut ? 'opacity-75 cursor-not-allowed' : ''}`} data-id="element-167">
                  {isCheckingOut ? <>
                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-168">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-169"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-170"></path>
                      </svg>
                      Processing...
                    </> : 'Proceed to Checkout'}
                </button>
                <div className="mt-4 text-center" data-id="element-171">
                  <p className="text-sm text-gray-500" data-id="element-172">
                    We accept credit cards, PayPal, and bank transfers
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}